import { Component, OnInit, Input } from '@angular/core';
import { DependentProfileDataService } from "../../services/dependent-profile-data.service";
import { BeneficiaryDetails } from 'src/app/data/models/beneficiaryDetails.model';
import { ApiServicesService } from '../../services/api-services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../../../services/authentication.service';
@Component({
  selector: 'app-ocr-converter',
  templateUrl: './ocr-converter.component.html',
  styleUrls: ['./ocr-converter.component.scss']
})
export class OcrConverterComponent implements OnInit {
  formDetails: any;
  documentType: any;
  primaryData = null;
  beneficiaryType: string;
  dependentDetailsLoaded = false;
  lifeStoryTabsLoaded = false;
  onlyFormBuilder;
  beneficiaryId: number;
  beneficiaryData: BeneficiaryDetails;
  observableSubscription$ = new Subject();
  @Input() detailsAbout: any;
  constructor(private authenticationService: AuthenticationService,
    private apiService: ApiServicesService, private router: Router,
    private dependentProfileDataService: DependentProfileDataService, private route: ActivatedRoute) {
    this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
  }

  ngOnInit(): void {
    this.dependentProfileDataService.onLifeStorySubTabs.subscribe(() => {
      this.lifeStoryTabsLoaded = true;
      this.triggerChangeDependentProfileID();
    });
    this.dependentDetailsLoaded = true;
    this.triggerChangeDependentProfileID();
  }

  onFormDetailsChange(data: any) {
    debugger;
    this.formDetails = data?.formDetails;
    this.documentType = data?.documentType
  }
  triggerChangeDependentProfileID() {
    this.beneficiaryType = this.detailsAbout.showDetailFor === 'self' ? 'self' : 'family';
    this.getBeneficiaryDetails();
    sessionStorage.setItem('beneficiaryTypeExp', this.beneficiaryType);
    sessionStorage.setItem('beneficiaryIdExp', this.beneficiaryType !== 'self' ?  this.beneficiaryData.id.toString() : null);
    
   if (this.dependentDetailsLoaded && this.lifeStoryTabsLoaded) {
      this.dependentProfileDataService.changeDependentProfileID(this.beneficiaryType !== 'self' ? this.beneficiaryData.id : null, this.beneficiaryType);
    }
  }
  getBeneficiaryDetails() {
    if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
      //this.emptyBeneficiaryData();
      this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'self').pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary: BeneficiaryDetails) => {
        this.beneficiaryData = { ...beneficiary, dob: beneficiary.dob && moment(beneficiary.dob, 'YYYY-MM-DD').toDate(), marriageDate: beneficiary.marriageDate && moment(beneficiary.marriageDate, 'YYYY-MM-DD').toDate(), ctznCrtfctIssDate: beneficiary.ctznCrtfctIssDate && moment(beneficiary.ctznCrtfctIssDate, 'YYYY-MM-DD').toDate(), passport: beneficiary.passport?.length ? [{ ...beneficiary.passport[0], expiryDate: beneficiary.passport[0].expiryDate && moment(beneficiary.passport[0].expiryDate, 'YYYY-MM-DD').toDate(), issueDate: beneficiary.passport[0].issueDate && moment(beneficiary.passport[0].issueDate, 'YYYY-MM-DD').toDate() }] : beneficiary.passport };
        //this.personalDetails.next(this.beneficiaryData);
       // this.setBeneficiaryFormData();
      });
    }
  }
  
}
